module.exports.SET_SIDEBAR = 'SET_SIDEBAR';
